import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/dashboard.png'
import _imports_1 from '@/assets/img/steps.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-4bde849b")

_pushScopeId("data-v-4bde849b")
const _hoisted_1 = { id: "bodyWrap" }
const _hoisted_2 = {
  class: "col-12 d-none d-sm-flex col-md-6 d-flex flex-column justify-content-center position-relative overflow-hidden",
  ref: "s3"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "product__backgroundsquare position-absolute" }, null, -1)
const _hoisted_4 = { class: "productPageContent" }
const _hoisted_5 = { class: "container p-4 product-section mt-5 " }
const _hoisted_6 = { class: "row h-100" }
const _hoisted_7 = { class: "col-12 col-md-6 flex-column d-flex justify-content-center px-5 align-items-center text-center align-items-md-start text-md-start" }
const _hoisted_8 = {
  class: "display-4 fw-normal",
  style: {"font-size":"36px"}
}
const _hoisted_9 = {
  class: "py-4 lh-base fw-normal",
  style: {"font-size":"18px"}
}
const _hoisted_10 = { class: "mt-5 mt-md-0 col-12 col-md-6 d-flex justify-content-center align-items-center position-relative" }
const _hoisted_11 = {
  key: 0,
  style: {"animation-duration":"1.5s"}
}
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "w-75 shadow br-20 dashboard-image",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "dashboard-square position-absolute h-100 w-75 br-20" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "section-separator" }, null, -1)
const _hoisted_15 = { class: "container p-4 product-section mb-5 mb-md-0" }
const _hoisted_16 = { class: "mt-5 mt-md-0 row h-100" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "order-2 order-md-1 col-12 col-md-6 d-flex justify-content-center align-items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "w-75 shadow br-20",
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_18 = { class: "order-1 order-md-2 col-12 col-md-6 flex-column d-flex justify-content-center align-item-center text-center px-5 align-items-md-start text-md-start" }
const _hoisted_19 = {
  class: "display-4 fw-normal",
  style: {"font-size":"36px"}
}
const _hoisted_20 = {
  class: "py-4 lh-base fw-normal",
  style: {"font-size":"18px"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Header = _resolveComponent("Header")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createVNode("div", _hoisted_2, [
      _hoisted_3
    ], 512),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("h1", _hoisted_8, _toDisplayString(_ctx.t("ProductPage.UnifiedReportingDashboard")), 1),
            _createVNode("h4", _hoisted_9, _toDisplayString(_ctx.t("ProductPage.AllTransactionsAreConsolidated")), 1)
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode(_TransitionGroup, {
              name: "fadeRight",
              tag: "div"
            }, {
              default: _withId(() => [
                (_ctx.s3_dashboard)
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      _hoisted_12,
                      _hoisted_13
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_14,
      _createVNode("div", _hoisted_15, [
        _createVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode("div", _hoisted_18, [
            _createVNode("h1", _hoisted_19, _toDisplayString(_ctx.t("ProductPage.EliminateFrictionAtCheckout")), 1),
            _createVNode("h4", _hoisted_20, _toDisplayString(_ctx.t("ProductPage.CustomersCanMakePayments")), 1)
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
})